import { render, staticRenderFns } from "./accesibilidad.vue?vue&type=template&id=150fc110&scoped=true"
import script from "./accesibilidad.vue?vue&type=script&lang=js"
export * from "./accesibilidad.vue?vue&type=script&lang=js"
import style0 from "./accesibilidad.vue?vue&type=style&index=0&id=150fc110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150fc110",
  null
  
)

export default component.exports